import React from 'react'

function Repos({ repos }) {
    return (
        <div className="repos">
            <h1 className="repos-title">Recent repositories</h1>
            {
                repos.map(repo => {
                    return (
                        <div key={repo.id} className="user repo-item">
                            <a href={repo.html_url} className="repo-link">{repo.name}</a>
                        </div>
                    )
                })
            }

        </div>
    )
}

export default Repos
